"use client";

import React from "react";

import analytics from "@ide/shared/lib/analytics";

const useAnalytics = () => {
  const track = React.useCallback((event, meta = undefined) => {
    if (!event) {
      return;
    }

    analytics.track(event, meta);

    // if (Array.isArray(window.dataLayer)) {
    //   // console.log("gtag push: ", event, meta, window.dataLayer);
    //   window.dataLayer.push({ event: event });
    // }

    // if (typeof window.sa_event === "function") {
    //   // console.log("simpleanalytics: ", event, meta);
    //   window.sa_event(event, meta);
    // }
  }, []);

  return { track };
};

export default useAnalytics;
